import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Col, Layout, Menu, Row, Space } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { logout, selectUser } from "../../../store/slices/authSlice";

const { Header } = Layout;

const AppHeader = ({ collapsed, setCollapsed }) => {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  return (
    <Header
      className="site-layout-background"
      style={{
        padding: 0,
        position: "sticky",
        top: 0,
        zIndex: 1,
        boxShadow: "0 6px 20px 0 rgba(0, 0, 0, 0.09)",
      }}
    >
      <Row justify="space-between">
        <Col>
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: "trigger",
              onClick: () => setCollapsed(!collapsed),
            }
          )}
        </Col>
        <Col>
          <Space>
            <div className="user">Hello, {user?.email}</div>
            <Menu mode="horizontal" theme="light">
              <Menu.Item key="logout" onClick={() => dispatch(logout())}>
                <Link to="#">Logout</Link>
              </Menu.Item>
            </Menu>
          </Space>
        </Col>
      </Row>
    </Header>
  );
};

export default AppHeader;
